/* Banner-only parallax. Other theme parallax handlers are intentionally unchanged. */
(() => {
  if (customElements.get('promotion-banner-parallax')) return;
  class PromotionBannerParallax extends HTMLElement {
    connectedCallback() {
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._frame = null;
      this._visible = false;
      this._scrolling = false;
      this._sync = () => {
        const image = [...this.querySelectorAll('img')].find(img =>
          img.getClientRects().length && img.getBoundingClientRect().width > 0 &&
          img.getAttribute('src') && getComputedStyle(img).objectFit === 'cover');
        this._active = !this._motion.matches && !!image && this.getBoundingClientRect().height > 0;
        this.classList.toggle('is-parallax-active', this._active);
        if (!this._active) this.style.removeProperty('--promotion-parallax-offset');
        this._setScrolling(this._active && this._visible);
        if (this._active && this._visible) this._queue();
      };
      this._queue = () => {
        if (this._frame !== null) return;
        this._frame = requestAnimationFrame(() => {
          this._frame = null;
          if (!this._active || !this.isConnected || this._motion.matches) return;
          const rect = this.getBoundingClientRect();
          const height = rect.height;
          if (height <= 0) return;
          const speed = (window.innerHeight / height) * 20;
          const limit = height / 11;
          const shift = Math.max(-limit, Math.min(limit, (rect.top - window.innerHeight) / speed));
          this.style.setProperty('--promotion-parallax-offset', shift + 'px');
        });
      };
      if (!('IntersectionObserver' in window)) return;
      this._observer = new IntersectionObserver(entries => {
        this._visible = entries.some(entry => entry.isIntersecting);
        this._sync();
      });
      this._observer.observe(this);
      if ('ResizeObserver' in window) {
        this._resizeObserver = new ResizeObserver(this._sync);
        this._resizeObserver.observe(this);
      }
      this._motion.addEventListener('change', this._sync);
      window.addEventListener('resize', this._sync, { passive: true });
      this.addEventListener('load', this._sync, true);
      this._sync();
    }
    _setScrolling(enabled) {
      if (enabled === this._scrolling) return;
      this._scrolling = enabled;
      if (enabled) window.addEventListener('scroll', this._queue, { passive: true });
      else {
        window.removeEventListener('scroll', this._queue);
        if (this._frame !== null) cancelAnimationFrame(this._frame);
        this._frame = null;
      }
    }
    disconnectedCallback() {
      this._observer?.disconnect();
      this._resizeObserver?.disconnect();
      this._resizeObserver = null;
      this._motion?.removeEventListener('change', this._sync);
      window.removeEventListener('resize', this._sync);
      window.removeEventListener('scroll', this._queue);
      this.removeEventListener('load', this._sync, true);
      if (this._frame !== null) cancelAnimationFrame(this._frame);
      this._frame = null;
      this._scrolling = false;
      this.classList.remove('is-parallax-active');
      this.style.removeProperty('--promotion-parallax-offset');
    }
  }
  customElements.define('promotion-banner-parallax', PromotionBannerParallax);
})();

